import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Collapse from '@material-ui/core/Collapse'
import Button from '@material-ui/core/Button'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

const useStyles = makeStyles({
  responseTree: {
    borderLeft: '2px solid #BCBCCB',
    paddingLeft: 24
  }
})

const TopicCard = ({ children, totalResponses, hideOpenButton = false }) => {
  const classes = useStyles()
  const [isOpen, setIsOpen] = useState(false)
  const toggleResponses = () => {
      setIsOpen(!isOpen)
  }
  if (hideOpenButton) {
    return <div className={classes.responseTree}>{children}</div>
  }
  return (
    !!totalResponses ? (<div className={classes.responseTree}>
        <Button startIcon={!isOpen ? <ExpandMoreIcon /> : <ExpandLessIcon />} onClick={toggleResponses}>{!isOpen ? 'Ver' : 'Ocultar'} respostas ({totalResponses})</Button>
        <Collapse in={!!isOpen}>
                {children}
        </Collapse>
    </div>) : null
  )
}
export default TopicCard
